import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { CommandPalette } from "./CommandPalette";
import { C } from "@coremonit/design-system";
import { ErrorBoundary } from "./ErrorBoundary";
import { ExplorerProvider } from "../context/ExplorerContext";

export function RootLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [paletteOpen, setPaletteOpen] = useState(false);

  return (
    <ExplorerProvider>
      <div style={{ display: "flex", height: "100vh", background: C.bg, color: C.text }}>
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
          <Topbar onOpenPalette={() => setPaletteOpen(true)} />
          <main style={{ flex: 1, overflow: "auto", padding: 20 }}>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>
        <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      </div>
    </ExplorerProvider>
  );
}
